import { useEffect } from "react";
import { Platform, useColorScheme } from "react-native";
// @ts-ignore next-line
import favicon from "../../../../../assets/favicon.png";

export const useFaviconByTheme = (): void => {
  const themeScheme = useColorScheme();

  useEffect(() => {
    if (Platform.OS === "web") {
      const icons = document.querySelectorAll(
        "link[rel=\"icon\"],link[rel=\"shortcut icon\"]",
      );

      icons.forEach((link) => {
        link?.setAttribute("href", favicon);
      });
    }
  }, [themeScheme]);
};
